import { useMemo, useState } from "react";
import { CalendarRange, NotebookPen } from "lucide-react";
import { Reveal } from "../Reveal";
import { JPlanForm } from "./JPlanForm";
import { JPlanTimeline } from "./JPlanTimeline";
import { JDiary } from "./JDiary";
import { GENETICS, buildPlan, parseDate } from "../../lib/plan";
import { useGrow } from "../../lib/irrigation";

const Tab = ({ active, onClick, icon: Icon, children, testid }) => (
  <button onClick={onClick} data-testid={testid}
    className={`inline-flex items-center gap-2 h-11 px-5 rounded-full text-sm font-semibold transition-colors ${active ? "bg-[#F2B441] text-[#0E2A1C]" : "border border-[#F6EEDC]/30 hover:border-[#F2B441] hover:text-[#F2B441]"}`}>
    <Icon className="w-4 h-4" /> {children}
  </button>
);

export const JPlanner = () => {
  const [cfg, setCfg] = useGrow();
  const [tab, setTab] = useState("plan");
  const plan = useMemo(() => buildPlan(cfg), [cfg]);
  const weekFor = (date) => {
    const d = parseDate(date);
    return plan.weeks.find((w) => d >= w.from && d <= w.to)?.label ?? "";
  };

  return (
    <section id="mi-cultivo" data-testid="planner-section" className="relative py-24 md:py-36 bg-[#0B2216] border-y border-[#F2B441]/25">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="mb-10 md:mb-14 grid md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <p className="font-mono-d text-[11px] tracking-[0.22em] uppercase text-[#8CD05A]">Cuadrante de cultivo</p>
            <h2 className="font-serif-d font-black text-5xl md:text-7xl leading-[0.92] tracking-tight mt-6">
              Tu cultivo, <span className="italic font-semibold text-[#F2B441]">de semilla a cosecha.</span>
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <p className="text-[#C9D6C2] leading-relaxed">Elige tu genética y la duración: te damos el plan semana a semana con dosis Jungle, tareas y fecha de cosecha. Y apunta cada riego en tu diario.</p>
            <div className="mt-5 flex flex-wrap gap-2">
              <Tab active={tab === "plan"} onClick={() => setTab("plan")} icon={CalendarRange} testid="planner-tab-plan">Mi plan</Tab>
              <Tab active={tab === "diario"} onClick={() => setTab("diario")} icon={NotebookPen} testid="planner-tab-diary">Diario</Tab>
            </div>
          </div>
        </Reveal>
        {tab === "plan" ? (
          <div className="grid lg:grid-cols-12 gap-6">
            <div className="lg:col-span-4"><JPlanForm cfg={cfg} setCfg={setCfg} /></div>
            <div className="lg:col-span-8"><JPlanTimeline plan={plan} genetic={GENETICS[cfg.genetic].label} /></div>
          </div>
        ) : <JDiary weekFor={weekFor} />}
      </div>
    </section>
  );
};
